import { render, staticRenderFns } from "./ExportTranslationsModal.vue?vue&type=template&id=9f7f9f1a&scoped=true&"
import script from "./ExportTranslationsModal.vue?vue&type=script&lang=js&"
export * from "./ExportTranslationsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportTranslationsModal.vue?vue&type=style&index=0&id=9f7f9f1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7f9f1a",
  null
  
)

export default component.exports